import { Box, FormField, InputSelectField } from '@tempmee/react';
import { Controller, useFormContext } from 'react-hook-form';
import type { ISignUpFormValues } from '../../types';
import { YES_NO_OPTIONS } from '~/constants/officeProfileOptions';

const SECTION_GAP = 32;

export const AssistedHygieneSection = () => {
  const { control } = useFormContext<ISignUpFormValues>();

  return (
    <Box style={{ marginTop: SECTION_GAP }}>
      <FormField label="Will the Hygienist Have Assistant Support?" htmlFor="assistedHygiene">
        <Controller
          name="assistedHygiene"
          control={control}
          rules={{ required: true }}
          render={({ field, fieldState }) => (
            <div data-cy="select-assisted-hygiene">
              <InputSelectField<string>
                options={YES_NO_OPTIONS}
                value={field.value}
                onChange={field.onChange}
                placeholder="Select"
                isError={Boolean(fieldState.error)}
              />
            </div>
          )}
        />
      </FormField>
    </Box>
  );
};
